import React from 'react';
import { Container } from 'reactstrap';
import { get } from 'lodash-es';

import DiyTitleBar from './DiyTitleBar';
import DiyStepBar from './DiyStepBar';
import Step1 from './Step1/Step1';
import Step2 from './Step2/Step2';
import Step3 from './Step3/Step3';
import Step4 from './Step4/Step4';
import Step5 from './Step5/Step5';
import Step6 from './Step6/Step6';
import Step7 from './Step7/Step7';

const getCurrentStepComponent = step => {
  switch (step) {
    case 1:
      return <Step1 />;
    case 2:
      return <Step2 />;
    case 3:
      return <Step3 />;
    case 4:
      return <Step4 />;
    case 5:
      return <Step5 />;
    case 6:
      return <Step6 />;
    case 7:
      return <Step7 />;
    default:
      return <Step1 />;
  }
};

const DiyContainer = props => {
  // /session/live-timed/groupid/catalogid/step
  let step = parseInt(get(props, 'match.params.step', 1), 10);

  if (step <= 0) {
    step = 1;
  }
  document.title = 'InvaluableAuctions - DIY Session';

  return (
    <Container className="py-4">
      <DiyStepBar step={step} />
      <DiyTitleBar step={step} />

      {getCurrentStepComponent(step)}
    </Container>
  );
};

export default DiyContainer;
